import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

// img
import p1 from "../../../../Assets/images/p1.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GET_DRIVER_BY_ID } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";

const DriverReportView = () => {
  const { id } = useParams();

  const [driverReport, setDriverReport] = useState([]);
  const navigate = useNavigate();

  const getdriverReportData = async () => {
    try {
      const res = await GET_DRIVER_BY_ID(id);

      if (res.status === 200) {
        setDriverReport(res?.data);
      } else {
        toast.error("something went wrong");
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) getdriverReportData(id);
  }, []);

  return (
    <>
      <section className="fareDetail py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Link to="/reports/driver-report" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="12" className="my-3">
              <div className="top px-3 d-flex align-items-center justify-content-between gap-10 mb-3">
                <div className="left">
                  <h5 className="fw-sbold themeBlue m-0">
                    Driver Report Detail
                  </h5>
                </div>
              </div>
              <div className="cardCstm border rounded px-3 py-2">
                <div className="table-responsive">
                  <table className="table m-0">
                    <thead>
                      <tr>
                        <th className="text-muted text-center">Driver Name</th>
                        <th className="text-muted text-center">Driver Type</th>
                        <th className="text-muted text-center">
                          Accepted Rides
                        </th>
                        <th className="text-muted text-center">
                          Rejected Rides
                        </th>
                        <th className="text-muted text-center">
                          Completed Rides
                        </th>
                        <th className="text-muted text-center">Earning</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center text-danger border-0 fw-bold">
                          {driverReport?.driverName}
                        </td>
                        <td className="text-center text-danger border-0 fw-bold">
                          {driverReport?.driverType}
                        </td>
                        <td className="text-center text-danger border-0 fw-bold">
                          {driverReport?.acceptedRides}
                        </td>
                        <td className="text-center text-danger border-0 fw-bold">
                          {driverReport?.rejectedRides}
                        </td>
                        <td className="text-center text-danger border-0 fw-bold">
                          {driverReport?.completedRides}
                        </td>
                        <td className="text-center text-danger border-0 fw-bold">
                          {driverReport?.Earning}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DriverReportView;
